module.exports = __webpack_public_path__ + "media/images/common/print_btn_s_ov-966625614efc77bd02f1e1a75674c571.png";